import json from '@/api/DataProfile.json'

export default {
        singleView : false,
        active_portfolio : null,
        data : json         
}